import { applyMiddleware, combineReducers, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import {
  apiReducer,
  authReducer,
  cardReducer,
  commonReducer,
  debtReducer,
  employeeReducer,
  expenseReducer,
  fuelImportReducer,
  fuelReducer,
  fuelStatisticReducer,
  languageReducer,
  pumpReducer,
  pumpShiftReducer,
  receiptReducer,
  shiftReducer,
  stationReducer,
  supplierReducer,
  tankReducer,
  tankStatisticReducer,
  transactionReducer,
  userReducer,
  workScheduleReducer,
} from './reducers'
import { AuthAction, LOGOUT } from './types'

const appReducer = combineReducers({
  language: languageReducer,
  auth: authReducer,
  user: userReducer,
  station: stationReducer,
  tank: tankReducer,
  fuel: fuelReducer,
  api: apiReducer,
  pump: pumpReducer,
  supplier: supplierReducer,
  employee: employeeReducer,
  common: commonReducer,
  shift: shiftReducer,
  workSchedule: workScheduleReducer,
  fuelImport: fuelImportReducer,
  transaction: transactionReducer,
  card: cardReducer,
  pumpShift: pumpShiftReducer,
  debt: debtReducer,
  receipt: receiptReducer,
  expense: expenseReducer,
  fuelStatistic: fuelStatisticReducer,
  tankStatistic: tankStatisticReducer,
})

const rootReducer = (state: any, action: AuthAction) => {
  return appReducer(action.type === LOGOUT ? undefined : state, action)
}

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
)

export type RootState = ReturnType<typeof rootReducer>

export default store
